




















import { Component, Prop, Vue } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { Form, Textarea } from '@/pages/profile/blocks';
import { Button } from '@/pages/profile/components';
import { MeetingFormData } from './types';
import { DESCRIPTION } from './consts';

const getForm = () => ({
  text: '',
});

@Component({
  components: {
    Form,
    Button,
    Textarea,
  },
  mixins: [validationMixin],
})
export default class MentoringProgramForm extends Vue {
  @Prop({ type: Number, default: 0 })
  readonly meetingNumber!: number;

  resultForm: MeetingFormData = getForm();
  description: string = DESCRIPTION;

  get isDisabled(): boolean {
    const { $v } = this;
    return $v ? $v.$invalid : true;
  }

  get v() {
    const { $v } = this;
    return $v && $v.resultForm;
  }

  mounted(): void {
    this.reset();
  }

  validations(): any {
    const resultForm: any = {
      text: { required },
    };

    return { resultForm };
  }

  submitMeetingForm() {
    const { $v, resultForm } = this;
    if ($v) {
      $v.$touch();
      if (!$v.$invalid) {
        this.$emit('submitMeetingForm', { ...resultForm });
      }
    }
  }

  reset() {
    const { $v } = this;
    if ($v) $v.$reset();
    this.resultForm = { ...getForm() };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/modal/components/programform/MentoringProgramForm.vue